import { FilterOperator, useDataSourceListQuery } from '@kinetic-ui/data-layer';
import { getNodes } from 'kineticUtils';
import { useCallback } from 'react';

export const useIsLocationTypeSegment = (locationType?: string) => {
  const { data, loading } = useDataSourceListQuery({
    variables: {
      sourceId: 'locationType',
      filters: {
        field: 'attributes.GEOMETRY_TYPE',
        operator: FilterOperator.Equals,
        value: 'SEGMENT',
      },
    },
  });

  const nodes = getNodes(data?.dataSources) ?? [];
  const types = nodes.map((source) => source.value);
  const getIsLocationTypeSegment = useCallback(
    (type?: string) => {
      if (!type) {
        return false;
      }
      return types.includes(type);
    },
    [types]
  );

  return {
    isLocationTypeSegment: getIsLocationTypeSegment(locationType),
    getIsLocationTypeSegment,
    loading,
  };
};
